import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateIntervalValidation } from '@validators/date-interval-validation';
import { DateValidation } from '@validators/date.validation';
import moment from 'moment';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {

  public isFilterExpanded = false;

  public readonly defaultFilterValues = {
    initialDate: moment().subtract(1, 'month'),
    finalDate: moment(),
    locations: null,
    segments: null,
    companies: null,
    locationGroups: null,
    maintenanceTypes: null
  };

  public filterForm = new FormGroup({
    initialDate: new FormControl(this.defaultFilterValues.initialDate, [Validators.required, DateValidation.validate]),
    finalDate: new FormControl(this.defaultFilterValues.finalDate, [Validators.required, DateValidation.validate]),
    locations: new FormControl(this.defaultFilterValues.locations),
    maintenanceTypes: new FormControl(this.defaultFilterValues.maintenanceTypes),
    segments: new FormControl(this.defaultFilterValues.segments),
    companies: new FormControl(this.defaultFilterValues.companies),
    locationGroups: new FormControl(this.defaultFilterValues.locationGroups)
  },
    {
      validators: [
        DateIntervalValidation.validate({
          from: 'initialDate',
          to: 'finalDate',
          maxDiffLte: 1,
          unit: 'year'
        })
      ]
    });
}
